export enum ColumnType {
    Text = 'text',
    Number = 'number',
    Date = 'date',
    DateTime = 'datetime',
    NgbDate = 'ngbDate',
    Boolean = 'boolean'
}
